import React, { Component } from "react";
import Header from "@/bit/components/components.header";
import Footer from "@/bit/components/components.footer";
import MetaData from "@/bit/core/core.meta-data";
import { getStaticProps as getStaticPropsMethod } from "@/bit/pages/pages.ssr-pages-handler";
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import { wrapper } from "store";

class E404 extends Component {
  componentDidMount() {
    try {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://prod.cms.col.movistar.es/static/ts/next13/beach.style.min.css";
      document.head.appendChild(link);
    } catch (err) {
      // console.error(err)
    }
  }
  render() {
    const { breadcrumbsProps, headerProps, footerProps, seoInfo } = this.props;

    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />
        <div className="beach">
          <div className="messageContainer">
            <Text
              size={TEXT_SIZE.DISPLAY2}
              fontType={TEXT_FONT_WEIGHT.LIGHT}
              color={TEXT_COLOR.WHITE}
              align={TEXT_ALIGN.CENTER}
              text="404"
              cyData="404"
            />
            <Text
              size={TEXT_SIZE.TITLE45}
              fontType={TEXT_FONT_WEIGHT.LIGHT}
              color={TEXT_COLOR.WHITE}
              align={TEXT_ALIGN.CENTER}
              text="Lo sentimos, esta página no existe."
            />
          </div>
          <div className="cloud x1" />
          <div className="cloud x1_5" />
          <div className="cloud x2" />
          <div className="cloud x3" />
          <div className="cloud x4" />
          <div className="cloud x5" />
        </div>
        <Footer footerProps={footerProps} />
      </>
    );
  }
}

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const isNotProd = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod";
  const info = await getStaticPropsMethod(data, "", 0, {
    pathname: "/404",
    seoLocation: "www.movistar.es/404",
    headerLocation: "/404",
    layout: "ficha",
  });

  const allProps2Return = {
    props: {
      ...info.props,
    },
    revalidate: info.revalidate || 300,
  };

  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }

  return allProps2Return;
});

export default E404;
